import React from "react";
import "./css/ItineraryPage.css";

const ItineraryPage = () => {
  return (
    <div className="bhutanContainer">

      {/* <h1>PH-01 | Bhutan Himalayan Harmony</h1>
      <h2>4 Nights / 5 Days | Fly In – Fly Out</h2>

      <p><b>Thimphu (1N) – Punakha/Wangdue (1N) – Paro (2N)</b></p>

      <p>
        Experience the serene monasteries, dramatic Himalayan landscapes, and peaceful valleys of Bhutan in this carefully curated 5-day journey. Designed for travelers who seek culture, nature, and spiritual depth, this itinerary balances sightseeing with relaxed travel time.
      </p>

      <p><b>Ideal for:</b> Families, Couples, First-time Bhutan Visitors, Small Groups (FIT & GIT customization available)</p>

      <h3>Trip Highlights</h3>
      <ul>
        <li>Scenic drive across the iconic Dochu-La Pass</li>
        <li>Visit to the majestic Punakha Dzong</li>
        <li>Hike to the legendary Tiger’s Nest Monastery</li>
        <li>Explore Bhutan’s capital city Thimphu</li>
        <li>Cultural immersion in Paro Valley</li>
        <li>Himalayan views and peaceful countryside drives</li>
      </ul>

      <h3>Day 1 – Arrival in Paro | Transfer to Thimphu</h3>
      <p>Distance: 55 km | Driving Time: Approx. 1.5 hrs</p>
      <p>Altitude: 2,350 m</p>
      <p>Upon arrival at Paro Airport, you will be greeted by our Bhutan representative and transferred to Thimphu, the capital city of Bhutan.</p>
      <p>After hotel check-in and some time to refresh, begin your introduction to Bhutanese culture.</p>
      <p>Visit Kuenselphodrang (Buddha Dordenma), a massive seated Buddha statue overlooking Thimphu Valley. The site offers panoramic views of the city and surrounding hills.</p>
      <p>Continue to the National Memorial Chorten, built in memory of the Third King of Bhutan. It is one of the most active religious sites in the country.</p>
      <p>In the evening, explore the impressive Tashichho Dzong, the seat of Bhutan’s government and central monastic body.</p>
      <p>Overnight in Thimphu.</p>

      <h3>Day 2 – Thimphu to Punakha via Dochu-La Pass</h3>
      <p>Distance: 78 km | Driving Time: Approx. 3 hrs</p>
      <p>Altitude (Punakha): 1,310 m</p>
      <p>After breakfast, drive towards Punakha, crossing the scenic Dochu-La Pass (3,100 m). On a clear day, the pass offers breathtaking views of the Eastern Himalayas. The 108 Druk Wangyel Chortens, surrounded by colorful prayer flags, make this one of Bhutan’s most photographed locations.</p>
      <p>Upon arrival in Punakha, check in to your hotel.</p>
      <p>Visit the magnificent Punakha Dzong, one of Bhutan’s most beautiful fortresses, built in 1637. Located at the confluence of two rivers, it served as the seat of government until the mid-20th century.</p>
      <p>Later, enjoy a short and easy hike to Chhimi Lhakhang, also known as the Temple of Fertility, associated with Lama Drukpa Kuenley.</p>
      <p>Evening at leisure.</p>
      <p>Overnight in Punakha/Wangdue.</p>

      <h3>Day 3 – Punakha to Paro | Nature & Culture</h3>
      <p>Distance: 125 km | Driving Time: Approx. 5 hrs</p>
      <p>Altitude (Paro): 2,280 m</p>
      <p>After breakfast, drive back to Paro.</p>
      <p>En route, visit Lamperi Royal Botanical Park, home to a variety of Himalayan flora including several species of rhododendrons and birdlife.</p>
      <p>Upon arrival in Paro, check in at your hotel.</p>
      <p>In the afternoon, visit:</p>
      <ul>
        <li>Ta Dzong (National Museum) – housing Bhutanese art, relics, and traditional artifacts</li>
        <li>Rinpung Dzong – an architectural landmark serving as the administrative and judicial center of Paro</li>
      </ul>
      <p>Evening free to explore Paro town or relax.</p>
      <p>Overnight in Paro.</p>

      <h3>Day 4 – Tiger’s Nest Hike & Paro Valley</h3>
      <p>After breakfast, embark on the highlight of your Bhutan journey – the hike to Taktsang Monastery (Tiger’s Nest).</p>
      <p>Perched dramatically on a cliff 900 meters above Paro Valley, this sacred monastery is one of the most iconic sites in the Himalayas. The hike typically takes around 2–3 hours uphill (moderate difficulty). Pony services are available up to a certain point (subject to availability).</p>
      <p>After returning, visit:</p>
      <ul>
        <li>Drukgyel Dzong – historic fortress ruins with scenic mountain views</li>
        <li>Kyichu Lhakhang – one of Bhutan’s oldest and most sacred temples</li>
      </ul>
      <p>Overnight in Paro.</p>

      <h3>Day 5 – Departure from Paro</h3>
      <p>After breakfast, transfer to Paro Airport for your onward journey with peaceful memories of the Himalayan kingdom.</p> */}

      <h3>Best Time to Visit Bhutan</h3>
      <p>March to May and September to November are ideal for clear skies and comfortable weather. Spring offers blooming rhododendrons, while autumn provides excellent mountain views.</p>

      <h3>Travel Notes</h3>
      <ul>
        <li>Comfortable walking shoes are recommended for Tiger’s Nest hike.</li>
        <li>Altitude changes are gradual but staying hydrated is advised.</li>
        <li>Bhutan maintains a strong cultural code; modest dressing is appreciated at monasteries.</li>
      </ul>

      {/* WHY BOOK */}
<h3>Why Book Bhutan With Plenary Holidays?</h3>
<ul>
  <li>16+ years of structured travel experience</li>
  <li>Dedicated Bhutan specialists</li>
  <li>Flexible customization for FIT & GIT</li>
  <li>Transparent pricing & professional documentation</li>
  <li>Trusted network of local partners</li>
</ul>

{/* PRICING TABLE */}
<h3>Bhutan Package Pricing (Per Person)</h3>

<div className="tableWrap">
<table className="priceTable">
  <thead>
    <tr>
      <th>PAX</th>
      <th>Economy</th>
      <th>Superior</th>
      <th>Luxury</th>
      <th>Classy</th>
      <th>Splendid</th>
      <th>Premium</th>
      <th>Elite</th>
    </tr>
  </thead>

  <tbody>
    <tr><td>02 Pax</td><td>33200</td><td>35000</td><td>39800</td><td>48900</td><td>56100</td><td>79000</td><td>84300</td></tr>
    <tr><td>04 Pax</td><td>26500</td><td>28200</td><td>33000</td><td>42100</td><td>49300</td><td>72400</td><td>77800</td></tr>
    <tr><td>06 Pax</td><td>22700</td><td>24500</td><td>29200</td><td>38300</td><td>45500</td><td>68800</td><td>74100</td></tr>
    <tr><td>08 Pax</td><td>21400</td><td>23100</td><td>27900</td><td>37000</td><td>44200</td><td>67500</td><td>72800</td></tr>
  </tbody>
</table>
</div>

<p className="note">
Rates & services are subject to Bhutan Government regulations.
</p>

{/* ================= COMMON LINKS / PAGE 1 ================= */}

<h2>Common links/details for all BHUTAN Itineraries</h2>

{/* <h3>Page 1 : Bhutan-inclusions-exclusions</h3> */}

<h3>Accommodation Details</h3>

<h2>ACCOMMODATION</h2>

<div className="tableWrap">
<table className="priceTable">
<thead>
<tr>
<th>DESTINATIONS</th>
<th>ECONOMY (MAP)</th>
<th>SUPERIOR (MAP)</th>
<th>LUXURY (MAP)</th>
<th>CLASSY (MAP)</th>
<th>SPLENDID (MAP)</th>
<th>PREMIUM (MAP)</th>
<th>ELITE (MAP)</th>
</tr>
</thead>

<tbody>
<tr>
<td>PHUENTSHOLING</td>
<td>Gadhen Hotel (Deluxe) / Evergreen9 / Similar</td>
<td>Hotel Palm / Lhaki / Similar</td>
<td>Tara Phendeyling / Meto Pema / Similar</td>
<td>Bhutan Ga Me Ga (Standard) / Lotus Villa / Similar</td>
<td>Tashi Namgay Grand / Similar</td>
<td>Druk Hotel/ Similar</td>
<td>Druk Hotel / Similar</td>
</tr>

<tr>
<td>THIMPHU</td>
<td>Bhutan Kubera / Starlight / Similar</td>
<td>Migmar / Forest Boutique / Similar</td>
<td>Asura / Pelyang Boutique / Similar</td>
<td>Ariya / Tashi-Yid Wong / Similar</td>
<td>Termalinca Resorts And Spa / Himalayan Keys Forest Resort / Similar</td>
<td>Le Meridien (Classic) / Yarkay IHCL Seleqtions / Similar</td>
<td>Le Meridien (Deluxe) /Yarkay IHCL Seleqtions (Deluxe) / Similar</td>
</tr>

<tr>
<td>WANGDUE / PUNAKHA</td>
<td>White Dragon / Khuru Khuru / Similar</td>
<td>Pema Karpo / Classic Wood / Punakha Boutique / Similar</td>
<td>Zhingkham Resort / River Valley (Deluxe) / Similar</td>
<td>Rkpo Green Resort / Similar</td>
<td>Rkpo Green Resort / Similar</td>
<td>Dhensa Boutique Resort / Similar</td>
<td>Dhensa Boutique Resort / Similar</td>
</tr>

<tr>
<td>PARO</td>
<td>Gonju Boutique / Center Point / Similar</td>
<td>Gawaling / River Front / Similar</td>
<td>Paro Grand Resort (Deluxe) / Olathang (Deluxe Cottage) / Similar</td>
<td>Tiger Nest Camp / Tashi Namgay Resort (Deluxe) / Similar</td>
<td>Kaachi Grand (Sky Deck) / Jagathang / Similar</td>
<td>Le Meridian River Front (Classic) / Similar</td>
<td>Le Meridian - River Front (Deluxe) / Similar</td>
</tr>

<tr>
<td>BHUMTHANG</td>
<td>Hotel Ugyen Ling / Similar</td>
<td>Hotel Ugyen Ling / Similar</td>
<td>Yugharling Resort (Std.Dlx) / Similar</td>
<td>Yugharling Resort (Std.Dlx) / Similar</td>
<td>Bhutan Mountain Resort / Similar</td>
<td>Bhutan Mountain Resort / Similar</td>
<td>Bhutan Mountain Resort / Similar</td>
</tr>
</tbody>
</table>
</div>

<h3>Hotel Category Details:</h3>
<ul>
<li>Economy Packages : Decent Hotel with Breakfast & Dinner with all Modern Amenities.</li>
<li>Superior Packages : 3* Hotel with Breakfast & Dinner.</li>
<li>Luxury Packages : 3* Deluxe Hotel with Breakfast & Dinner</li>
<li>Classy Packages : 4* Equivalent Services with Breakfast and Dinner.</li>
<li>Splendid Packages : 4* Hotel with Breakfast & Dinner.</li>
<li>Premium Packages : 5* or 4* Hotel with Breakfast & Dinner.</li>
<li>Elite Packages : 5* Deluxe Hotels & other Best available hotels (In this category)</li>
</ul>

<h3>Important Information</h3>

<h4>Accommodation Standards & Upgrades</h4>
<ul>
<li>Property Selection: We strive to maintain consistent star ratings across your itinerary. However, in certain remote or niche destinations, where specific categories may not be available, we handpick the best available local alternative to ensure your comfort and safety.</li>
<li>Ultra-Luxury Portfolio: For guests seeking an elevated experience, we offer exclusive rates and bespoke arrangements with premier luxury collections, including Como Uma, The Postcard, Pemako, Amankora, and Six Senses. These are available upon request and customized on a case-to-case basis.</li>
</ul>

<h4>Culinary Experience</h4>
<ul>
<li>Menu Offerings: Our partner hotels serve a basic variety of freshly prepared Vegetarian and Non-Vegetarian options. The focus is on providing wholesome, local, and standard flavors.</li>
<li>Dietary Notes: While we ensure high-quality basic Indian cuisine, please note that specialized regional or niche Indian ethnic dishes may be limited by local ingredient availability. We recommend sharing any specific dietary requirements with us in advance to help our partners prepare accordingly.</li>
</ul>

{/* <h3>Cost Includes</h3>
<ul>
<li>Accommodation on a twin-sharing / double Sharing basis in selected hotels.</li>
<li>Meals as specified in the itinerary.</li>
<li>Exclusive private vehicle for all transfers and sightseeing as per the program.</li>
<li>All applicable permit fees and hotel taxes included in the itinerary.</li>
<li>Professional English-speaking guide services for the Bhutan sector.</li>
<li>Sustainable Development Fee (SDF) as mandated by the Government of Bhutan.</li>
<li>The above rates are applicable for Indian Nationals only.</li>
</ul>

<h3>Cost Excludes</h3>
<ul>
<li>Airfare, train fare, or any other mode of travel not specifically mentioned in the itinerary.</li>
<li>Personal expenses such as laundry, telephone calls, tips, gratuities, mineral water, beverages (soft or alcoholic), adventure activities (rafting, rock climbing, paragliding), and porterage charges.</li>
<li>Additional sightseeing, optional tours, or extended use of vehicles beyond the approved itinerary.</li>
<li>Entry fees to monuments, museums, parks, and other sightseeing attractions unless specifically mentioned in the inclusions.</li>
<li>Any expenses arising due to unforeseen circumstances such as natural calamities (landslides, road blockages), political disturbances, strikes, or other force majeure events. Such costs are to be borne directly by the client at the time of occurrence.</li>
<li>Any increase in government taxes, fuel surcharges, or transportation costs that may come into effect prior to departure and result in a revision of package cost.</li>
<li>Applicable GST, TCS, and Travel Insurance.</li>
<li>Any services or items not specifically mentioned under “Cost Includes.”</li>
</ul> */}

<h3>Entry Permit for Bhutan (Indian Nationals)</h3>
<p>Indian nationals do not require a visa to travel to Bhutan. However, a valid Entry Permit is mandatory for travel beyond the border checkpoints.</p>

<h4>Required Documents</h4>
<ul>
<li>Valid Indian Passport (with minimum 6 months validity from date of travel), OR</li>
<li>Original Indian Voter ID Card (physical card only)</li>
<li>Valid Travel Insurance covering the duration of stay in Bhutan is mandatory.</li>
<li>Passport-size photographs may be required as per prevailing regulations.</li>
</ul>

<p>Please note: Aadhaar Card, PAN Card, Driving License, or digital copies are not accepted as valid travel documents for entry into Bhutan.</p>

<h4>Advance Online Permit Processing</h4>
<ul>
<li>Clear, colored scanned copy of Passport (if traveling on Passport)</li>
<li>Travel Insurance copy</li>
<li>Recent passport-size photograph</li>
<li>Any additional documents required under current Bhutan regulations</li>
</ul>

<p>All documents must reach us at least 10 working days prior to departure.</p>

<p>Permit approval remains subject to the discretion of Bhutan immigration authorities.</p>

{/* ================= PAGE 2 ================= */}

<h3>`Bhutan-Travel-advisory-indians</h3>

<h2>Bhutan Travel Advisory for Indian Nationals (2026)</h2>

<ul>
<li>SDF for Indians: A mandatory fee of INR 1,200 per person per night is applicable.</li>
<li>Travel Insurance is mandatory.</li>
<li>Local SIM available on arrival.</li>
<li>Layered clothing recommended.</li>
<li>Photography restricted inside monasteries.</li>
<li>Smoking prohibited in public places.</li>
</ul>

{/* DOWNLOAD CHECKLIST */}

<h2>The Ultimate Bhutan Travel Checklist</h2>

<ul>
<li>Original Passport or Voter ID</li>
<li>Passport Size Photos</li>
<li>Travel Insurance copy</li>
<li>Cash small denominations</li>
<li>Layered clothing</li>
<li>Hiking shoes</li>
<li>Power bank</li>
<li>Offline Google Maps</li>
</ul>

<div className="">
<h4>3. Mobile Connectivity & Internet</h4>
<ul>
<li>Roaming: Indian mobile networks may not function reliably. We recommend checking with your provider for specific international roaming packs.</li>
<li>Local SIMs: Local SIM cards can be arranged upon arrival at the border or airport (subject to providing a copy of your permit and ID).</li>
<li>Wi-Fi: Available in most hotels, though speeds may vary in remote or higher-altitude valleys.</li>
</ul>

<h4>4. Weather, Clothing & Altitude</h4>
<p>Bhutan’s climate varies significantly by altitude and season.</p>
<ul>
<li>Spring (March–May): Pleasant weather with blooming rhododendrons.</li>
<li>Autumn (September–November): Clear skies and peak mountain visibility.</li>
<li>Winter: Higher valleys can be very cold; layered clothing is essential.</li>
<li>Footwear: Comfortable walking shoes are a must, particularly for the Tiger’s Nest (Paro Taktsang) hike.</li>
<li>Altitude Health: Thimphu and Paro are above 2,000m. Stay hydrated, avoid overexertion on Day 1, and consult a doctor if you have respiratory or cardiac conditions.</li>
<li>Pony services for Tiger's Nest are available up to the midpoint for those requiring assistance.</li>
</ul>

<h4>5. Road Travel & Driving Conditions</h4>
<ul>
<li>Mountainous Terrain: Roads are scenic but winding. Driving speeds are moderate for safety.</li>
<li>Buffer Time: Landslides or roadblocks can occur during the monsoon. We advise a relaxed itinerary with buffer time for travel between districts.</li>
<li>Vehicles: We recommend using locally authorized Bhutanese transport for better navigation and compliance with local permits.</li>
</ul>

<h4>6. Cultural Etiquette & Photography</h4>
<ul>
<li>Attire: Modest dress is mandatory for Dzongs (fortresses) and monasteries. Shoulders and knees must be covered.</li>
<li>Sacred Spaces: Photography is strictly prohibited inside religious premises. Always seek permission before photographing local people.</li>
<li>Behavior: Avoid loud behavior or littering in sacred spaces. Respect the "High-Value, Low-Impact" tourism philosophy.</li>
</ul>

<h4>7. Responsible & Sustainable Travel</h4>
<ul>
<li>Tobacco: Smoking in public places is strictly prohibited and carries heavy fines.</li>
<li>Local Support: We encourage travelers to support local handicrafts and artisans, ensuring that tourism benefits the Bhutanese community directly.</li>
</ul>

<h3>The Ultimate Bhutan Travel Checklist</h3>
<p>Prepared by Plenary Holidays – Your MICE & Leisure Experts</p>
<ul>
<li>Original Passport or Voter ID: (Aadhar is not valid).</li>
<li>Passport Size Photos: Carry at least 4 recent photographs.</li>
<li>Birth Certificate: Original English copy for minors (under 18).</li>
<li>Travel Insurance: Copy of your comprehensive policy (mandatory).</li>
<li>Permit Copies: Multiple photocopies of your entry permit once issued.</li>
<li>Cash (Small Denominations): INR 100 and 200 notes are most reliable.</li>
<li>Cards: International Debit/Credit cards (ensure 'International Usage' is enabled).</li>
<li>UPI: BHIM/PhonePe work in major towns but carry cash for remote areas.</li>
<li>The 3-Layer Rule: Thermals, a light fleece/sweater, and a windproof/waterproof jacket.</li>
<li>Monastery Attire: Collared shirts/tops and full-length trousers (mandatory for Dzongs).</li>
<li>Hiking Gear: Broken-in walking shoes/hiking boots for Tiger’s Nest.</li>
<li>Accessories: Sunglasses, a wide-brimmed hat, and a reusable water bottle.</li>
<li>Altitude Meds: Consult your doctor for Diamox or similar (Thimphu/Paro are at high altitudes).</li>
<li>Motion Sickness: Essential if you are prone to nausea on winding mountain roads.</li>
<li>Sun Protection: High-SPF sunscreen and lip balm (the mountain sun is strong).</li>
<li>Personal Meds: A 15-day supply of any regular medication.</li>
<li>Universal Adapter: Most hotels use Indian/European style sockets, but a multi-pin is safer.</li>
<li>Power Bank: Essential for long driving days between valleys.</li>
<li>Offline Maps: Download Google Maps for Bhutan for offline use.</li>
</ul>

</div>


    </div>
  );
};

export default ItineraryPage;